export enum PopupButtonsTypes {
  Ok,
  OkCancel,
  YesNo,
}
